var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('HeaderComponent',{attrs:{"id":"header"}}),_c('SidebarComponent',{attrs:{"id":"sidebar"}}),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('AlertsComponent'),_vm._t("default",null,{"id":"view-container"})],2)],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }